import React, { useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import * as Icons from 'react-feather'
import User from './User'

const ROLE_KEYS = ['customer', 'photographer', 'admin', 'agent']

export default function UserList({
	users,
	clients,
	onCreateUserAction = () => {},
}) {
	const [query, setQuery] = useState('')
	const [roles, setRoles] = useState(
		ROLE_KEYS.reduce((acc, k) => ({ ...acc, [k]: false }), {})
	)

	const norm = (v) => {
		return (v ? v : '')
			.toString()
			.toLowerCase()
			.normalize('NFD')
			.replace(/[\u0300-\u036f]/g, '')
	}

	const filteredUsers = useMemo(() => {
		let q = norm(query).trim()
		const activeCount = ROLE_KEYS.filter((k) => roles[k]).length
		const noRoleFilter = activeCount === 0 || activeCount === ROLE_KEYS.length

		const matches = users.filter((u) => {
			const role = u.permission_level || 'customer'

			if (!noRoleFilter && !roles[role]) return false
			if (!q) return true

			const firstname = norm(u.firstname)
			const lastname = norm(u.lastname)
			const email = norm(u.email)

			// must match something
			return firstname.includes(q) || lastname.includes(q) || email.includes(q)
		})

		// name matches before email
		return matches.sort((a, b) => {
			const aNameMatch =
				norm(a.firstname).includes(q) || norm(a.lastname).includes(q)
			const bNameMatch =
				norm(b.firstname).includes(q) || norm(b.lastname).includes(q)

			if (aNameMatch && !bNameMatch) return -1
			if (!aNameMatch && bNameMatch) return 1
			return 0 //original order
		})
	}, [users, query, roles])

	const toggleRole = (key) => setRoles((r) => ({ ...r, [key]: !r[key] }))

	return (
		<div className='userList__container'>
			<div className='userList__sidebar'>
				<div className='sidebarInner'>
					<div className='sidebarGroup'>
						<button
							className='btn'
							onClick={onCreateUserAction}
							style={{ padding: '12px 18px' }}
						>
							<Icons.Plus size={16} /> Create User
						</button>
					</div>

					<div className='sidebarGroup'>
						<input
							type='text'
							id='search'
							className='inp'
							value={query}
							onChange={(e) => setQuery(e.target.value)}
							placeholder='Search by name or email...'
							style={{
								width: '100%',
								padding: '24px 16px',
								background: '#ffffff',
							}}
						/>
					</div>

					<div className='sidebarGroup'>
						<div style={{ fontWeight: 600, marginBottom: 10 }}>Role</div>
						<label className='checkRow'>
							<input
								type='checkbox'
								checked={roles.customer}
								onChange={() => toggleRole('customer')}
							/>
							<span>Client</span>
						</label>
						<label className='checkRow'>
							<input
								type='checkbox'
								checked={roles.photographer}
								onChange={() => toggleRole('photographer')}
							/>
							<span>Stringer</span>
						</label>
						<label className='checkRow'>
							<input
								type='checkbox'
								checked={roles.admin}
								onChange={() => toggleRole('admin')}
							/>
							<span>Administrator</span>
						</label>
						<label className='checkRow'>
							<input
								type='checkbox'
								checked={roles.agent}
								onChange={() => toggleRole('agent')}
							/>
							<span>Agent</span>
						</label>
					</div>

					<div className='sidebarGroup'>
						<small style={{ opacity: 0.7 }}>
							Showing {filteredUsers.length} of {users.length}
						</small>
					</div>
				</div>
			</div>

			<div className='userList'>
				{filteredUsers.map((user) => (
					<User user={user} clients={clients} key={user.user_id} />
				))}
			</div>
		</div>
	)
}

UserList.propTypes = {
	users: PropTypes.array.isRequired,
	clients: PropTypes.object.isRequired,
	onCreateUserAction: PropTypes.func,
}

UserList.defaultProps = {
	onCreateUserAction: () => {},
}
